module.exports = __webpack_public_path__ + "static/refinancovani.113391cb.jpg";